// extracted by mini-css-extract-plugin
export default {"main":"AddContact_main__jEHYS","number_contact":"AddContact_number_contact__HJ3MQ","accordion__item":"AddContact_accordion__item__rQDok"};